import { render, staticRenderFns } from "./ListTelefoneUtil.vue?vue&type=template&id=3227778f&"
import script from "./ListTelefoneUtil.vue?vue&type=script&lang=js&"
export * from "./ListTelefoneUtil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports